import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';

// Component to protect routes that require authentication and specific roles
const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { isAuthenticated, loading, user } = useContext(AuthContext);
  
  // If still loading, don't redirect yet
  if (loading) {
    return <div>Loading...</div>;
  }
  
  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  
  // If allowedRoles is provided and not empty, check if user has the required role
  if (allowedRoles && allowedRoles.length > 0) {
    const userRole = user?.role?.toLowerCase();
    
    if (!userRole || !allowedRoles.map(role => role.toLowerCase()).includes(userRole)) {
      // Redirect based on role
      if (userRole === 'manager') {
        return <Navigate to="/audit/my-cases" />;
      } else if (userRole === 'reviewer') {
        return <Navigate to="/audit/my-cases" />;
      } else {
        return <Navigate to="/unauthorized" />;
      }
    }
  }
  
  // If authenticated and has the required role (or no role check required), render the children
  return children;
};

export default ProtectedRoute;
